import CardPosition from "features/quiz/models/rearrangementQuiz/cardPosition";

export default class RearrangementQuizAnswer {
  constructor(public readonly positions: CardPosition[]) {}
}
